import { rpm } from 'bmiq-common';

const { cptCodes } = rpm;

export const rpmLogsData = {
  count: 5,
  rpmEvents: [
    {
      text: 'Consent Received',
      value: 2,
    },
    {
      text: 'Consent Removed',
      value: 3,
    },
    {
      text: 'RPM Provider Updated',
      value: 1,
    },
    {
      text: 'Unmark Patient as RPM',
      value: 4,
    },
    {
      text: 'Mark Patient as RPM',
      value: 5,
    },
    {
      text: 'Device Connected',
      value: 6,
    },
    {
      text: 'Service Initiation',
      value: 7,
    },
    {
      text: 'Consent Rejected',
      value: 8,
    },
    {
      text: 'RPM Reading threshold met',
      value: 9,
    },
  ],
  rows: [
    {
      id: 1,
      providerId: 218,
      dataInfo: {
        note: '<p>Note goes here</p>\n',
        headline: `Note's headline`,
        deviceName: 'Rpm Device Name',
        deviceType: 'RPM Device Type',
        serviceInitiationDate: '2021-09-24T13:05:43.046Z',
      },
      userId: 2831,
      status: 0,
      organizationName: 'Test2 Medical Center',
      organizationId: 11,
      rpmEventName: 'Service Initiation - waiting',
      CPT: cptCodes.CPT_SERVICE_INITIATION,
      updatedAt: '2021-09-24T13:06:27.041Z',
      patientId: 110,
      user: {
        id: 307,
        user_detail: {
          firstName: 'Test',
          lastName: 'Patient2',
        },
        patient: {
          id: 110,
        },
      },
      provider: {
        id: 218,
        providers_users: [
          {
            userId: 248,
            user: {
              id: 248,
              user_detail: {
                firstName: 'Alice1',
                lastName: 'in Chains',
              },
            },
          },
        ],
      },
    },
    {
      id: 2,
      providerId: 218,
      dataInfo: {
        note: '<p>Note goes here</p>\n',
        headline: `Note's headline`,
        deviceName: 'Rpm Device Name',
        deviceType: 'RPM Device Type',
        serviceInitiationDate: '2021-09-24T13:05:43.046Z',
      },
      userId: 2831,
      status: 1,
      organizationName: 'Test2 Medical Center',
      organizationId: 11,
      rpmEventName: 'Service Initiation - ready',
      CPT: cptCodes.CPT_SERVICE_INITIATION,
      updatedAt: '2021-09-24T13:06:27.041Z',
      patientId: 110,
      user: {
        id: 307,
        user_detail: {
          firstName: 'Test',
          lastName: 'Patient2',
        },
        patient: {
          id: 110,
        },
      },
      provider: {
        id: 41,
        providers_users: [
          {
            userId: 248,
            user: {
              id: 248,
              user_detail: {
                firstName: 'Alice1',
                lastName: 'in Chains',
              },
            },
          },
        ],
      },
    },
    {
      id: 3,
      noteStatus: null,
      providerId: 92,
      dataInfo: null,
      organizationName: 'Test1 Medical Center',
      organizationId: 11,
      rpmEventName: 'Mark Patient as RPM',
      CPT: null,
      userId: 2831,
      status: 1,
      updatedAt: '2021-09-24T13:06:27.041Z',
      patientId: 111,
      user: {
        id: 307,
        user_detail: {
          firstName: 'Test',
          lastName: 'Patient1',
        },
        patient: {
          id: 110,
        },
      },
      provider: {
        id: 41,
        providers_users: [
          {
            userId: 248,
            user: {
              id: 248,
              user_detail: {
                firstName: 'Alice1',
                lastName: 'in Chains',
              },
            },
          },
        ],
      },
    },
    {
      id: 4,
      providerId: 218,
      dataInfo: null,
      userId: 2833,
      status: 1,
      organizationName: 'Test Medical Center',
      organizationId: 15,
      rpmEventName: 'Device Connected',
      CPT: null,
      updatedAt: '2021-09-24T13:06:27.041Z',
      patientId: 112,
      user: {
        id: 307,
        user_detail: {
          firstName: 'Test',
          lastName: 'Patient3',
        },
        patient: {
          id: 110,
        },
      },
      provider: {
        id: 41,
        providers_users: [
          {
            userId: 248,
            user: {
              id: 248,
              user_detail: {
                firstName: 'Alice1',
                lastName: 'in Chains',
              },
            },
          },
        ],
      },
    },
    {
      id: 5,
      providerId: 218,
      dataInfo: null,
      userId: 2831,
      status: 1,
      organizationName: 'Test2 Medical Center',
      organizationId: 11,
      rpmEventName: 'RPM Reading threshold met',
      CPT: cptCodes.CPT_RPM_THRESHOLD_MET,
      updatedAt: '2021-09-24T13:06:27.041Z',
      patientId: 110,
      user: {
        id: 307,
        user_detail: {
          firstName: 'Test',
          lastName: 'Patient2',
        },
        patient: {
          id: 110,
        },
      },
      provider: {
        id: 41,
        providers_users: [
          {
            userId: 248,
            user: {
              id: 248,
              user_detail: {
                firstName: 'Alice1',
                lastName: 'in Chains',
              },
            },
          },
        ],
      },
    },
  ],
};
